/* HomePlunge buy box, v2. Payment selector + accessory add-ons.
   Split out of the Buy Box custom_liquid block for the same 50KB reason. */
(function () {
  /*
    Two small, independent behaviours. Both are defensive: if the markup is not
    on the page (older cached template, a variant of this block without add-ons)
    every query returns nothing and this script does nothing at all.
  */
  function wirePay() {
    var root = document.querySelector('.hpp-pay');
    if (!root || root.dataset.hppPayWired) return;
    root.dataset.hppPayWired = '1';
    var tabs = root.querySelectorAll('[data-hpp-pay]');
    var panels = root.querySelectorAll('[data-hpp-panel]');
    if (!tabs.length || !panels.length) return;

    function select(key) {
      for (var i = 0; i < tabs.length; i++) {
        tabs[i].setAttribute('aria-selected', tabs[i].dataset.hppPay === key ? 'true' : 'false');
      }
      for (var j = 0; j < panels.length; j++) {
        panels[j].classList.toggle('is-active', panels[j].dataset.hppPanel === key);
      }
    }

    root.addEventListener('click', function (e) {
      var tab = e.target.closest ? e.target.closest('[data-hpp-pay]') : null;
      if (!tab || !root.contains(tab)) return;
      e.preventDefault();
      select(tab.dataset.hppPay);
    });

    // Left and right arrows move between tabs, which is what a tablist owes a
    // keyboard user once the panels are hidden from view.
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var list = Array.prototype.slice.call(tabs);
      var at = list.indexOf(document.activeElement);
      if (at === -1) return;
      e.preventDefault();
      var next = list[(at + (e.key === 'ArrowRight' ? 1 : list.length - 1)) % list.length];
      next.focus();
      select(next.dataset.hppPay);
    });
  }

  function wireAddons() {
    var btns = document.querySelectorAll('[data-hpp-addon]');
    for (var i = 0; i < btns.length; i++) {
      (function (btn) {
        if (btn.dataset.hppAddonWired) return;
        btn.dataset.hppAddonWired = '1';
        btn.addEventListener('click', function (e) {
          // This block lives inside the product form. Without both of these a
          // click would submit the form and add a chiller instead.
          e.preventDefault();
          e.stopPropagation();
          var id = parseInt(btn.dataset.hppAddon, 10);
          if (!id) return;
          var was = btn.textContent;
          btn.disabled = true;
          btn.textContent = 'Adding';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
          }).then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          }).then(function () {
            btn.textContent = 'Added';
            // Let the theme's cart drawer and any cart apps catch up. Different
            // themes listen on different events, so fire the ones this theme uses.
            try {
              document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
              document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
            } catch (err) {}
            fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
              document.querySelectorAll('.cart-count-bubble span,[data-cart-count]').forEach(function (b) {
                b.textContent = cart.item_count;
              });
            }).catch(function () {});
          }).catch(function () {
            // Never strand the buyer on a dead button.
            btn.disabled = false;
            btn.textContent = was;
          });
        });
      })(btns[i]);
    }
  }

  function init() { wirePay(); wireAddons(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
